import { Component, OnInit } from '@angular/core';
import {DialogsService} from '../../services/dialogs.service';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {HelpInfo} from '../../models/help-info.interface';
import {Page} from '../../../shared/models/page.interface';
import {Router} from '@angular/router';
import {MessageService} from '../../../shared/services/message.service';
import {HelpInfoSearch} from '../../models/help-info-search.interface';

@Component({
  selector: 'app-kf-dialog',
  templateUrl: './dialogs.component.html',
  styleUrls: ['./dialogs.component.scss']
})
export class DialogsComponent implements OnInit {
  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  dialogs!: Page<HelpInfo>;
  private search!: HelpInfoSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'id', direction: 'asc'};

  constructor(private readonly dialogsService: DialogsService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.dialogsService.getAll({}, this.page).subscribe(
      data => this.dialogs = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadDialogs(event: PageRequest): void {
    this.page = event;
    if (this.search) {
      this.dialogsService.getAll(this.search, event).subscribe(
        data => this.dialogs = data
      );
    }
    else {
      this.dialogsService.getAll({}, event).subscribe(
        data => this.dialogs = data
      );
    }
  }

  searchDialogs(search: HelpInfoSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'id' , direction: 'asc'};
    }
    this.dialogsService.getAll(search, this.page).subscribe(
      data => this.dialogs = data
    );
  }

}
